import {ListaPaginadaComponent} from './lista-paginada.component';
import {NgModule} from '@angular/core';
import {MatButtonModule, MatPaginatorModule, MatSortModule, MatTableModule, MatTooltipModule} from '@angular/material';
import {CommonModule} from '@angular/common';



@NgModule({
	declarations: [
		ListaPaginadaComponent
	],
	imports: [
		MatPaginatorModule,
		MatTableModule,
		MatSortModule,
		MatButtonModule,
		CommonModule,
		MatTooltipModule,
	],
	exports:[
		ListaPaginadaComponent
	]
})
export class ListaPaginadaModule { }
